import React, { useState } from "react";
import { FaInfoCircle } from "react-icons/fa";

function FloatingLabelDropdown({
  label,
  options,
  value,
  defaultValue,
  onChange,
  onBlur,
  error,
  name,
}) {
  const isValid = value !== "";
  const shouldShowError = !isValid && error;

  return (
    <div>
      <div className="relative h-[60px] border-2">
        <select
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          name={name}
          defaultValue={defaultValue}
          className={`block text-black  w-full px-[20px] h-full appearance-none focus:outline-none focus:ring-0 peer ${
            error
              ? "border-red-500 focus:border-red-500"
              : "border-gray-300 focus:border-blue-600"
          }`}
        >
          <option value="" disabled>{`${label}`}</option>
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <label
          className={`absolute text-sm text-gray-500
          duration-300 transform -translate-y-4 font-muli scale-75 left-[20px] top-[16px] z-10 origin-[0] peer-focus:left-[20px] peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4`}
        >
          {label}
        </label>

        {/* {shouldShowError && (
          <p className="mt-2 text-sm text-red-500">
            {`Please select a ${label.toLowerCase()}.`}
          </p>
        )} */}
      </div>
      {error && (
        <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
          <FaInfoCircle />
          <p className="text-white py-1 px-2  text-sm my-2 ">{error}</p>
        </div>
      )}
    </div>
  );
}

export default FloatingLabelDropdown;
